import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20">
      <div className="container-custom">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            涵盖六大内容板块，满足你对不同领域的求知需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200 flex-shrink-0">
                  <i className={`${category.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {category.name}
                  </h3>
                  <p className="mt-1 text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {category.description}
                  </p>
                  <p className="mt-3 text-xs text-foreground-400">
                    {category.articleCount} 篇内容
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}